module.exports = __webpack_public_path__ + "img/sala-do-empreendedor.2e6d7f37.png";